<template>
  <div class="step-varieties">
    <!-- Bob/Charlie: intermediate or expert -->
    <template v-if="wizardData.experience_level && wizardData.experience_level !== 'beginner'">
      <h2 class="step-title">Add your varieties later</h2>
      <p class="skip-description">
        You can import from CSV or add varieties one by one from the variety library.
      </p>
    </template>

    <!-- Alice: beginner or no selection -->
    <template v-else>
      <h2 class="step-title">What do you want to grow?</h2>
      <p class="step-subtitle">We'll add a few to start.</p>

      <div class="category-grid">
        <button
          v-for="cat in categories"
          :key="cat.value"
          class="category-card"
          :class="{ selected: wizardData.selectedCategories.includes(cat.value) }"
          type="button"
          @click="toggleCategory(cat.value)"
        >
          <span class="cat-emoji">{{ cat.emoji }}</span>
          <span class="cat-label">{{ cat.label }}</span>
          <span v-if="wizardData.selectedCategories.includes(cat.value)" class="cat-check">✓</span>
        </button>
      </div>

      <p v-if="wizardData.selectedCategories.length" class="selection-count">
        {{ wizardData.selectedCategories.length }}
        {{ wizardData.selectedCategories.length === 1 ? 'category' : 'categories' }} selected
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StepVarieties',

  props: {
    wizardData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      categories: [
        { value: 'solanacee', emoji: '🍅', label: 'Tomates' },
        { value: 'salade', emoji: '🥗', label: 'Salades' },
        { value: 'aromate', emoji: '🌿', label: 'Herbes' },
        { value: 'cucurbitacee', emoji: '🥒', label: 'Cucurbitacées' },
        { value: 'fraise', emoji: '🍓', label: 'Fraises' },
        { value: 'racine', emoji: '🥕', label: 'Racines' },
        { value: 'legumineuse', emoji: '🫘', label: 'Légumineuses' },
      ],
    }
  },

  methods: {
    toggleCategory(value) {
      const selected = this.wizardData.selectedCategories.includes(value)
        ? this.wizardData.selectedCategories.filter((c) => c !== value)
        : [...this.wizardData.selectedCategories, value]
      this.$emit('update:wizardData', { ...this.wizardData, selectedCategories: selected })
    },
  },
}
</script>

<style scoped>
.step-varieties {
  padding-bottom: 8px;
}

.step-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 8px;
}

.step-subtitle {
  color: #6b7280;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

.skip-description {
  color: #6b7280;
  line-height: 1.6;
  margin-top: 12px;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.category-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 16px 8px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.category-card:hover {
  border-color: #a3e635;
}

.category-card.selected {
  border-color: #65a30d;
  background: #f7fee7;
}

.cat-emoji {
  font-size: 1.75rem;
}

.cat-label {
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  color: #374151;
}

.cat-check {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #65a30d;
}

.selection-count {
  margin-top: 14px;
  font-size: 0.85rem;
  color: #6b7280;
  text-align: center;
}
</style>
